var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("multiselect", {
        staticClass: "city-select",
        class: _vm.inputClasses,
        attrs: {
          name: _vm.name,
          id: _vm.id,
          label: _vm.label,
          autocomplete: _vm.autocomplete,
          placeholder: _vm.placeholder,
          options: _vm.options,
          clearable: _vm.clearable,
          searchable: _vm.searchable || _vm.filterable,
          multiple: _vm.multiple,
          disabled: _vm.disabled,
          "allow-empty": _vm.allowEmpty,
          selectLabel: null,
          selectGroupLabel: null,
          selectedLabel: null,
          deselectLabel: null,
          deselectGroupLabel: null,
          "group-values": _vm.groupValues,
          "group-label": _vm.groupLabel,
          "group-select": _vm.groupSelect,
          "track-by": _vm.trackBy,
        },
        on: {
          input: _vm.handleModelInput,
          remove: _vm.handleRemove,
          open: function ($event) {
            return _vm.handleFocus(true)
          },
          close: function ($event) {
            return _vm.handleFocus(false)
          },
        },
        model: {
          value: _vm.valueCopy,
          callback: function ($$v) {
            _vm.valueCopy = $$v
          },
          expression: "valueCopy",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "material-label",
          class: _vm.activeClass,
          attrs: { for: _vm.id },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.error
        ? _c("small", { staticClass: "invalid-feedback" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }